import { css } from "@emotion/css";

import { grey } from "@/modules/theme/utils/colors";
import { Theme } from "@/modules/theme/utils/createTheme";

export const createTutorialItemStyles = ({
  spacing,
  borderRadius,
  typography,
  palette,
}: Theme) => ({
  root: css({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textDecoration: "none",
    position: "relative",
    margin: spacing([2, 2, 0, 2]),
    maxWidth: 110,
  }),
  content: css({
    margin: spacing(1),
    borderRadius: borderRadius.round,
    width: 88,
    height: 88,
    backgroundColor: grey[100],
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
  }),
  tutorialName: css({
    marginTop: spacing(1),
    textAlign: "center",
  }),
  point: css({
    display: "flex",
    alignItems: "center",
    marginLeft: spacing(2),
    fontSize: typography.pxToRem(14),
    color: palette.default.text,
  }),

  pointSteps: css({
    fontSize: typography.pxToRem(17),
    marginBottom: spacing(0.5),
  }),
  totalStepsNumber: css({
    color: grey[550],
  }),
  tutorialDoneIcon: css({
    position: "absolute",
    bottom: spacing(-0.5),
    right: spacing(-1),
  }),
});
